<ng-container *ngIf="value === 'PENDIENTE'; else estadoTexto">

  <button nbButton size="tiny" status="primary" (click)="asignarTarea()">
    ASIGNAR
  </button>

</ng-container>

<ng-template #estadoTexto>

  <span *ngIf="value === 'ASIGNADA'">Asignada</span>
  <span *ngIf="value === 'INICIADA'">Iniciada</span>
  <span *ngIf="value === 'FINALIZADA'">Finalizada</span>

</ng-template>